import React, { useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import useTranslator from "../../hooks/useTranslator";
import { useNavigate, useParams } from "react-router-dom";
import AuthContext from "../../context/auth/AuthContext";
import { haveValue, shouldDeductNextView } from "../../helper/common";
import LandLordContext from "../../context/landlord/LandLordContext";
import Cancelimg from "../../assets/img/cancel-01.svg";
import CreditDeductionPopup from "../../pages/landlord/profile-request/CreditDeductionPopup";

const AwardPropertyPopup = ({
  awardPopupModal,
  setAwardPopupModal,
  selectedTenants,
  property,
  rentVal,
}) => {
  const navigate = useNavigate();
  const { _t } = useTranslator();
  const { workspaceId } = useParams();
  const [rent, setRent] = useState(property?.report_rent ?? null);
  const [deposit, setDeposit] = useState(property?.report_deposit ?? null);
  const [openConfirmationPopup, setOpenConfirmationPopup] = useState(false);
  const { updateRentDepositReport, deaWorkspace } = useContext(LandLordContext);
  const { user, setLoading } = useContext(AuthContext);
  const [rootNavigate, setRootNavigate] = useState(null);
  const [totalProfilesForDeduction, setTotalProfilesForDeduction] =
    useState(null);

  useEffect(() => {
    setRent(property?.report_rent);
    setDeposit(property?.report_deposit);
  }, [property]);

  useEffect(() => {
    if (awardPopupModal) {
      handleGenerateReport();
    }
  }, [awardPopupModal]);

  const handleChangeRent = (e) => {
    setRent(e.target.value);
  };

  const handleDepositChange = (e) => {
    setDeposit(e.target.value);
  };

  const calculateOpenPrice = async () => {
    setLoading(true);
    try {
      let numberOfTenantsToDeductPrice = 0;

      for (let tProfile of selectedTenants) {
        const checkView = await shouldDeductNextView(user, tProfile?._id);
        if (checkView) {
          numberOfTenantsToDeductPrice++;
        }
      }

      return numberOfTenantsToDeductPrice;
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleGenerateReport = () => {
    let queryParams = "";

    const data_temp = {
      report_rent: rentVal,
    };
    updateRentDepositReport(property?._id, data_temp);

    const params = new URLSearchParams(window.location.search);
    params.set("propertyId", property?._id);

    selectedTenants.map((tenantProfile) => {
      // if (user?.isParentLL) {
      //   queryParams += `agencylink=${tenantProfile?.agency_tenant_link_id}&`;
      // } else {
      queryParams += `sharedprofileid=${tenantProfile?._id}&`;
      params.append("sharedprofileid", tenantProfile?._id);
      // }
    });
    queryParams += `rent=${rent}`;
    if (haveValue(property?._id)) {
      queryParams += `&property=${property?._id}`;
    }
    const redirectUrl = window.location.pathname + window.location.search;
    queryParams += `&redirectUrl=${encodeURIComponent(redirectUrl)}`;

    const totalProfiles = calculateOpenPrice();

    const propertyName = `${property?.street} - ${
      Number.isNaN(parseInt(property?.street_number, 10))
        ? "N/A"
        : String(parseInt(property?.street_number, 10))
    }, ${property?.floor_number}${
      property?.flat_number ? ` - ${property?.flat_number}` : ""
    }`;

    params.set("propName", propertyName);
    if (totalProfiles > 0) {
      setRootNavigate(
        user?.current_workspace?.dea_rules_activated
          ? `${
              haveValue(workspaceId) ? "/" + workspaceId : ""
            }/report-overview?${queryParams}`
          : `${
              haveValue(workspaceId) ? "/" + workspaceId : ""
            }/generatedReport/combinedReport?${queryParams}`,
      );
      setOpenConfirmationPopup(true);
      setTotalProfilesForDeduction(totalProfiles);
    } else {
      navigate(
        user?.current_workspace?.dea_rules_activated
          ? `${
              haveValue(workspaceId) ? "/" + workspaceId : ""
            }/report-overview?${queryParams}`
          : `${
              haveValue(workspaceId) ? "/" + workspaceId : ""
            }/generatedReport/combinedReport?${queryParams}`,
      );
    }
  };

  return (
    <>
      <Modal
        show={false}
        className="metermodal wrapper-modal modal-xl custom-modal-popup"
        centered
        onHide={() => setAwardPopupModal(false)}
      >
        <Modal.Header>
          <h2 className="modal-title-text">
            {_t(
              "generateReportAndAwardPropertyHeading",
              "Award property/Generate report popup heading when LL selects tenants from property list..",
            )}
          </h2>
          <div
            className="cursor-pointer"
            onClick={() => setAwardPopupModal(false)}
          >
            <img
              src={Cancelimg}
              alt="icon"
              className="canceicon topRightIcon"
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="bodyContentset">
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="forminput customInput">
                <label className="forminput label-text">
                  <h6 className="modal-label">
                    {_t("Rent Price", "Award property popup form label")}
                  </h6>
                </label>
                <input
                  type="number"
                  name="Rent Price"
                  className="modal-input"
                  placeholder={_t(
                    "Enter Rent Price",
                    "Award property popup form placeholder",
                  )}
                  value={rent}
                  onChange={handleChangeRent}
                />
              </div>
              <div className="forminput customInput">
                <label className="forminput label-text">
                  <h6 className="modal-label">
                    {_t(
                      "Number Of Deposit Month",
                      "Award property popup form label",
                    )}
                  </h6>
                </label>
                <input
                  type="number"
                  name="Enter months"
                  className="modal-input"
                  onChange={handleDepositChange}
                  placeholder={_t(
                    "Enter months",
                    "Award property popup form placeholder",
                  )}
                  value={deposit}
                />
              </div>
              <div className=" row100 gridbar popup_btn2">
                <button
                  className="addGuarantorButton modal-btn"
                  type="submit"
                  onClick={handleGenerateReport}
                  disabled={!haveValue(rent) || !haveValue(deposit)}
                >
                  {_t("submit")}
                </button>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
      <CreditDeductionPopup
        openModal={openConfirmationPopup}
        setOpenModal={setOpenConfirmationPopup}
        openReport={() => navigate(rootNavigate)}
        totalProfiles={totalProfilesForDeduction}
      />
    </>
  );
};

export default AwardPropertyPopup;
